

























import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import request, { Response } from '@/helpers/requests'
import { OnSubmitEvent } from '@/components/ui/types'


enum CardState {
    LOADING = 'loading',
    READY = 'ready',
    ERROR = 'error'
}


export interface DefaultServerResponse extends Response {
    message: string;
    data: unknown;
}


export {
    OnSubmitEvent
}

@Component({})
export default class TechTaskCard<RequestPayload, ServerResponse extends DefaultServerResponse> extends Vue {
    @Prop() title !: string
    @Prop() taskName !: string
    @Prop() requestPayload !: RequestPayload
    @Prop({ default: false }) disableButton !: boolean
    @Prop({ default: true }) displayActions !: boolean
    @Prop({ default: false }) loading !: boolean
    responseData: ServerResponse|null = null
    showSuccess = false
    cardState: CardState = CardState.READY
    message: string|null = null

    get cardError(): boolean {
        return this.cardState === CardState.ERROR
    }

    get cardLoading(): boolean {
        return this.cardState === CardState.LOADING || this.loading
    }

    handleError(message: string) {
        this.message = message
        this.cardState = CardState.ERROR
    }

    @Emit('on-submit')
    async submit(): Promise<OnSubmitEvent<ServerResponse>> {
        try {
            this.message = null
            this.cardState = CardState.LOADING
            const response: ServerResponse = await request.post(`/support/${this.taskName}/submit`, {
                ...this.requestPayload
            }) as ServerResponse
            this.cardState = CardState.READY
            this.showSuccess = true
            this.responseData = response
            return {
                success: true,
                response
            }
        } catch(e) {
            this.handleError(e.message)
            return {
                success: false,
                response: null
            }
        }
    }
}
